export enum PriceTypeEnum {
    Store = "Store Fitting",
    MobileFitting = "Mobile Fitting",
    Delivery = "Delivery Price"
}
